// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicBrandPerceptionBarChart } from "./plasmic/basil_site_2_0/PlasmicBrandPerceptionBarChart";

function BrandPerceptionBarChart_(props, ref) {
  // Use PlasmicBrandPerceptionBarChart to render this component as it was
  // designed in Plasmic, by activating the appropriate variants,
  // attaching the appropriate event handlers, etc.  You
  // can also install whatever React hooks you need here to manage state or
  // fetch data.
  //
  // Props you can pass into PlasmicBrandPerceptionBarChart are:
  // 1. Variants you want to activate,
  // 2. Contents for slots you want to fill,
  // 3. Overrides for any named node in the component to attach behavior and data,
  // 4. Props to set on the root node.
  //
  // By default, we are just piping all BrandPerceptionBarChartProps here, but feel free
  // to do whatever works for you.

  const chartWithScroll = props.sentimentBarChart ? (
    <div style={{
      overflowX: 'auto',
      overflowY: 'hidden',
      width: '100%',
      minWidth: '300px',
      maxWidth: '100%',
      marginLeft: '0px', // Push chart away from left text
      paddingBottom: '20px' // Space for vertical labels
    }}>
      <div style={{
        minWidth: '100%',
        width: 'max-content',
        height: 'initial'
      }}>
        {props.sentimentBarChart}
      </div>
    </div>
  ) : props.sentimentBarChart;

  return <PlasmicBrandPerceptionBarChart
    root={{ ref }}
    {...props}
    sentimentBarChart={chartWithScroll}
  />;
}

const BrandPerceptionBarChart = React.forwardRef(BrandPerceptionBarChart_);

export default BrandPerceptionBarChart;
